import { SERVICES, SERVICE_ORDER } from "@/lib/constants";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="bg-[#FFF9E6]">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="md:grid md:grid-cols-5 md:gap-12 mb-14">
          <div className="md:col-span-3">
            <h2 className="text-3xl md:text-4xl text-[#1A243B] mb-5">Our services</h2>
            <p className="text-base md:text-lg text-[#2D3748] leading-relaxed max-w-xl">
              Book one student, a whole family, or your entire co-op. Testing is in person; consultations and tutoring support learning all year.
            </p>
          </div>
          <div className="hidden md:block md:col-span-2 relative rounded-3xl overflow-hidden min-h-[180px]">
            <img
              src="/images/girl-writing.png"
              alt="A student concentrating on her written test"
              data-testid="services-image"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-6">
          {SERVICE_ORDER.map((key) => {
            const s = SERVICES[key];
            return (
              <div
                key={key}
                data-testid={`service-card-${key}`}
                className="bg-white rounded-3xl p-8 shadow-sm hover:shadow-md transition-shadow flex flex-col"
              >
                <span className="font-display italic text-[#1A243B]/40 text-lg">{s.num}</span>
                <h3 className="text-2xl text-[#1A243B] mt-2 mb-1">{s.name}</h3>
                <p className="font-bold text-[#1A243B] mb-3" data-testid={`service-price-${key}`}>
                  ${s.price} <span className="font-semibold text-[#2D3748] text-sm">{s.unit}</span>
                </p>
                <p className="text-[#2D3748] text-base leading-relaxed mb-6 flex-1">{s.desc}</p>
                <div>
                  <a data-testid={`service-book-${key}`} href={`#book?service=${key}`} className="cta-pill inline-block bg-[#FFC107] text-[#1A243B] text-sm font-bold px-6 py-2.5 rounded-full">
                    Book online
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
